<template>
    <div :class="$style.container"
         id="institutions"
         style="height: 100%"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div :class="$style.top" :libraryId="libraryId" style="height: 100%">
            <div style="height: 100%">
                <div style="width: 100%;height: 180px;">
                    <el-row >
                        <el-col :span="20">
                            <div align="left" style="padding-top: 8px; color: cornflowerblue">
                        <span style="color: black; font-size: 14px">{{product_num || 0}}个产品  &nbsp; 机构 {{tableInstutionsListLength || 0}}
                            家&nbsp;
                            | &nbsp; 门店 {{tableRetailstoreListLength || 0}}
                            家&nbsp; |
                            &nbsp;经销商 {{tableDistributorListLength || 0}} 家</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" style="margin-top: 10px">
                        <span v-for="(item,index) in cityList" style="font-size: 12px;
                        display: inline-block;margin-top: 5px;margin-right: 10px;
                        padding: 5px 12px;border:1px solid #FF9901;color: #FF9901;
                        border-radius: 5px">
                            {{item.province_name}}-{{item.city_name}}
                        </span>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 40px;">
                        <el-col>
                            <el-button @click="addInstitutions" type="success"
                                       v-if="medicalName"
                                       icon="el-icon-plus"
                                       size="small">
                                添加机构</el-button>
                            <el-button @click="addStore" type="success"
                                       v-if="retailName"
                                       icon="el-icon-plus"
                                       size="small">
                                添加门店</el-button>
                            <el-button @click="addDistributor" type="success"
                                       v-if="distributionName"
                                       icon="el-icon-plus"
                                       size="small">
                                添加经销商</el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-row style="margin-top: 15px;height: calc(100% - 200px)">
                    <el-tabs v-model="activeName" @tab-click="tabHandleClick" style="height: 100%" class="eltabs">
                        <el-tab-pane label="医疗机构"  style="overflow-y: auto;">
                            <el-table :data="tableInstutionsList" stripe border ref="multipleTable">
                                <el-table-column
                                        min-width="200"
                                        prop="institution_name"
                                        label="名称"
                                        sortable>
                                </el-table-column>
                                <el-table-column
                                        min-width="200"
                                        prop="address"
                                        label="地址"
                                        sortable
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="array[0].count"
                                        sortable
                                        width="120"
                                        label="医务人员">
                                </el-table-column>
                                <el-table-column
                                        min-width="120"
                                        sortable
                                        label="产品">
                                    <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{item.product_name}}
                                      </span>
                                        <span>

                                      </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        width="160"
                                        fixed="right" label="操作"
                                        label-class-name="institutions_table_cell"
                                >
                                    <template slot-scope="scope" style="text-align: center">
                                        <div class="tempCell">
                                            <el-button
                                                    style="background: #FF9901;color: white;
                                                    border:1px solid #FF9901;"
                                                    size="small"
                                                    @click="clickModelInstutionsList(scope.index,scope.row)">详情
                                            </el-button>
                                            <el-button
                                                    type="danger" size="small" style=""
                                                    @click="clickRemove(scope.index,scope.row)">移除
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="零售终端">
                            <el-table :data="tableRetailstoreList" stripe border ref="multipleTable">
                                <el-table-column
                                        min-width="200"
                                        sortable
                                        prop="store_name"
                                        label="名称"
                                >
                                </el-table-column>
                                <el-table-column
                                        min-width="200"
                                        sortable
                                        prop="address"
                                        label="地址"
                                >
                                </el-table-column>
                                <el-table-column
                                        sortable
                                        width="120"
                                        prop="clerk_num"
                                        label="店员">
                                </el-table-column>
                                <el-table-column
                                        min-width="120"
                                        sortable
                                        label="产品">
                                    <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{item.product_name}}
                                      </span>
                                        <span>

                                      </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        width="160"
                                        label="操作"
                                        fixed="right"
                                        label-class-name="institutions_table_cell"
                                >
                                    <template slot-scope="scope" style="text-align: center">
                                        <div class="tempCell">
                                            <el-button
                                                    style="background: #FF9901;color: white;
                                                    border:1px solid #FF9901;" size="small"
                                                    @click="clickModelRetailstoreList(scope.$index, scope.row)">详情
                                            </el-button>
                                            <el-button
                                                    type="danger" size="small" style=""
                                                    @click="clickRemoveRetailstoreList(scope.$index, scope.row)">移除
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="分销客户">
                            <el-table :data="tableDistributorList" stripe border ref="multipleTable">
                                <el-table-column
                                        min-width="200"
                                        sortable
                                        prop="distributor_name"
                                        label="名称"
                                >
                                </el-table-column>
                                <el-table-column
                                        min-width="200"
                                        sortable
                                        prop="address"
                                        label="地址"
                                >
                                </el-table-column>
                                <el-table-column
                                        sortable
                                        width="120"
                                        prop="userInfo[0].count"
                                        label="联系人">
                                </el-table-column>
                                <el-table-column
                                        min-width="120"
                                        sortable
                                        label="产品">
                                    <template slot-scope="scope" style="text-align: center">
                                      <span class="tableSpan"
                                            v-for="(item,index) in scope.row.productArray" :key="index">
                                         {{item.product_name}}
                                      </span>
                                        <span>

                                      </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        width="160"
                                        label="操作"
                                        fixed="right"
                                        label-class-name="institutions_table_cell">
                                    <template slot-scope="scope" style="text-align: center">
                                        <div class="tempCell">
                                            <el-button
                                                    style="background: #FF9901;color: white;
                                                    border:1px solid #FF9901;" size="small"
                                                    @click="clickModelDistributorList(scope.$index, scope.row)">详情
                                            </el-button>
                                            <el-button
                                                    type="danger" size="small" style=""
                                                    @click="clickRemoveDistributorList(scope.$index, scope.row)">移除
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>
            </div>
        </div>

        <el-dialog title="" :visible.sync="addModelInstitutions" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加机构</span>
                <span>
                <el-button @click="inputSaveAddInstitutions" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeAddModelInstitutions" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" :model="addFormInstiturions" style="width: 80%;margin: auto" ref="addFormInstiturions"
                     label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{addFormInstiturions.territory_name}}&nbsp;&nbsp;({{addFormInstiturions.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="机构名称" label-width="100px" class="institutions_star"
                              prop="sname" :rules="[{ required: true, message: '机构名称不能为空'},]">
                    <el-row>
                        <el-col :span="21" :push="2">
                            <!--                            <el-autocomplete-->
                            <!--                                    style="width: 100%"-->
                            <!--                                    value-key="institution_name"-->
                            <!--                                    popper-class="my-autocomplete"-->
                            <!--                                    v-model = "sname"-->
                            <!--                                    :fetch-suggestions="querySearchAsync"-->
                            <!--                                    placeholder="搜索机构"-->
                            <!--                                    @select="handleSelect">-->
                            <!--                                <template slot-scope="props">-->
                            <!--                                    <div class="name">-->
                            <!--                                        {{ props.item.institution_name }}-->
                            <!--                                    </div>-->
                            <!--                                </template>-->
                            <!--                            </el-autocomplete>-->
                            <el-cascader
                                    style="width: 100%"
                                    v-model="addFormInstiturions.sname"
                                    @change="handleSelect"
                                    :show-all-levels="false"
                                    :filterable="true"
                                    :options="institution_list"
                                    :props="casccader_ter"
                                    clearable></el-cascader>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="100px"
                              prop="productArray" >
                    <el-row>
                        <el-col :span="21" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="addFormInstiturions.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="" :visible.sync="addModelStore" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加门店</span>
                <span>
                <el-button @click="inputSaveAddStore" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeAddModelStore" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" :model="addFormStore" style="width: 80%;margin: auto" ref="addFormStore"
                     label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{addFormStore.territory_name}}&nbsp;&nbsp;({{addFormStore.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="门店名称" label-width="100px" class="institutions_star"
                              prop="snamestore" :rules="[{ required: true, message: '门店名称不能为空'},]">
                    <el-row>
                        <el-col :span="21" :push="2">
                            <!--                            <el-autocomplete-->
                            <!--                                    style="width: 100%"-->
                            <!--                                    value-key="store_name"-->
                            <!--                                    popper-class="my-autocomplete"-->
                            <!--                                    v-model = "snamestore"-->
                            <!--                                    :fetch-suggestions="querySearchAsync"-->
                            <!--                                    placeholder="搜索门店"-->
                            <!--                                    @select="handleSelectStore">-->
                            <!--                                <template slot-scope="props">-->
                            <!--                                    <div class="name">-->
                            <!--                                        {{ props.item.store_name }}-->
                            <!--                                    </div>-->
                            <!--                                </template>-->
                            <!--                            </el-autocomplete>-->
                            <el-cascader
                                    style="width: 100%"
                                    v-model="addFormStore.snamestore"
                                    @change="handleSelectStore"
                                    :show-all-levels="false"
                                    :filterable="true"
                                    :options="store_list"
                                    :props="casccader_ter"
                                    clearable></el-cascader>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="100px"
                >
                    <el-row>
                        <el-col :span="21" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="addFormStore.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="" :visible.sync="addModelDistributorList" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">添加经销商</span>
                <span>
                <el-button @click="inputSaveAddDistributorList" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeAddModelDistributorList" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" :model="addFormDistributorList" style="width: 80%;margin: auto" ref="addFormDistributorList"
                     label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="110px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{addFormDistributorList.territory_name}}&nbsp;&nbsp;({{addFormDistributorList.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="经销商名称" label-width="110px" class="institutions_star"
                              prop="snameDistributorList" :rules="[{ required: true, message: '经销商名称不能为空'},]">
                    <el-row>
                        <el-col :span="21" :push="2">
                            <!--                            <el-autocomplete-->
                            <!--                                    style="width: 100%"-->
                            <!--                                    value-key="distributor_name"-->
                            <!--                                    popper-class="my-autocomplete"-->
                            <!--                                    v-model = "snameDistributorList"-->
                            <!--                                    :fetch-suggestions="querySearchAsync"-->
                            <!--                                    placeholder="搜索经销商"-->
                            <!--                                    @select="handleSelectDistributorList">-->
                            <!--                                <template slot-scope="props">-->
                            <!--                                    <div class="name">-->
                            <!--                                        {{ props.item.distributor_name }}-->
                            <!--                                    </div>-->
                            <!--                                </template>-->
                            <!--                            </el-autocomplete>-->
                            <el-cascader
                                    style="width: 100%"
                                    v-model="addFormDistributorList.snameDistributorList"
                                    @change="handleSelectDistributorList"
                                    :show-all-levels="false"
                                    :filterable="true"
                                    :options="distributor_list"
                                    :props="casccader_ter"
                                    clearable></el-cascader>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="110px"
                              prop="productArray" >
                    <el-row>
                        <el-col :span="21" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="addFormDistributorList.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="" :visible.sync="modelInstitutions" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">机构详情</span>
                <span>
                <el-button @click="inputUpdateInstitutions" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeModelInstitutions" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" ref="formInstiturions" :model="formInstiturions" style="width: 80%;margin: auto" label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formInstiturions.territory_name}}&nbsp;&nbsp;({{formInstiturions.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="机构名称" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formInstiturions.institution_name}}
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="100px"
                              prop="productArray" >
                    <el-row>
                        <el-col :span="22" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="formInstiturions.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addTerProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="" :visible.sync="modelRetailstoreList" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">门店详情</span>
                <span>
                <el-button @click="inputUpdateRetailstoreList" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeModelRetailstoreList" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" ref="formRetailstoreList" :model="formRetailstoreList" style="width: 80%;margin: auto" label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formRetailstoreList.territory_name}}&nbsp;&nbsp;({{formRetailstoreList.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="门店名称" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formRetailstoreList.store_name}}
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="100px"
                              prop="productArray" >
                    <el-row>
                        <el-col :span="22" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="formRetailstoreList.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addTerProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="" :visible.sync="modelDistributorList" :show-close="false">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
                <span style="color: #3998F7;font-size: 22px;padding-top: 5px">经销商详情</span>
                <span>
                <el-button @click="inputUpdateDistributorList" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeModelDistributorList" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" ref="formDistributorList" :model="formDistributorList" style="width: 80%;margin: auto" label-position="left" hide-required-asterisk>
                <el-form-item label="所属辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formDistributorList.territory_name}}&nbsp;&nbsp;({{formDistributorList.territory_code}})
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="经销商名称" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;" :push="2">
                            {{formDistributorList.distributor_name}}
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="推广产品"  label-width="100px"
                              prop="productArray">
                    <el-row>
                        <el-col :span="21" :push="2">
                            <el-select @emove-tag="emoveTag" style="width: 100%"
                                       v-model="formDistributorList.productArray"
                                       multiple
                                       filterable
                                       placeholder="请选择"
                                       >
                                <el-option
                                        v-for="(item,index) in addTerProductArray"
                                        :key="index"
                                        :label="item.product_name"
                                        :value="item.product_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import http from '../../APIService/http'
    export default {
        name: "institutionsTow",
        data(){
            return {
                sname:'',
                snamestore:'',
                snameDistributorList:'',
                loading:true,
                modelInstitutions : false,
                modelRetailstoreList: false,
                modelDistributorList:false,
                addModelDistributorList:false,
                form:{},
                tableInstutionsList:[],
                tableRetailstoreList:[],
                tableDistributorList:[],
                tableInstutionsListLength:0,
                tableRetailstoreListLength:0,
                tableDistributorListLength:0,
                product_num:0,
                formInstiturions:{
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    institution_name:'',
                    institution_id:'',
                    territory_id:'',
                    productArraySelect:[]
                },
                formRetailstoreList:{
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    institution_name:'',
                    institution_id:'',
                    territory_id:'',
                    productArraySelect:[]
                },
                formDistributorList:{
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    institution_name:'',
                    institution_id:'',
                    territory_id:'',
                    productArraySelect:[]
                },
                addModelInstitutions:false,
                addModelStore:false,
                addFormInstiturions:{
                    sname:'',
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    institution_name:'',
                    territory_id:'',
                    institution_id:''
                },
                addFormStore:{
                    snamestore:'',
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    store_name:'',
                    territory_id:'',
                    store_id:''
                },
                addFormDistributorList:{
                    snameDistributorList:'',
                    productArray: [],
                    territory_name:'',
                    territory_code:'',
                    distributor_name:'',
                    territory_id:'',
                    distributor_id:''
                },
                addProductArray:[],
                addTerProductArray:[],
                medicalName : true,
                retailName : false,
                distributionName : false,
                cityList:[],
                institution_list:[],
                store_list:[],
                distributor_list:[],
                casccader_ter:{
                    checkStrictly: false,
                    value : "id",
                    label : "label",
                    disabled : "disabled",
                    emitPath:false
                },
            }
        },
        watch: {
            $route (to,from){
                //console.log(this.$route.params.data)
                this.data=JSON.parse(this.$route)
                this.getPeople()
            }
        },
        methods:{
            async getCity(){
                try {
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id= this.$store.getters.getUser.tenant_id
                    await http.post('/wapi/Jur/getCityList',data).then(res=>{
                        console.log(res,111)
                        if (res.success === true){
                            this.cityList =  res.data
                        }

                    })
                }catch (e) {

                }
            },
            changeEveryOne(item){
                console.log(item)
            },
            async getinstitution_list(){
                try {
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    await  http.post('/wapi/Jur/getInstitutions',data).then(res=>{
                        if (res.success === true){
                            this.institution_list = res.data
                            // console.log(res.data,567)
                        }
                    })
                }catch (e) {

                }
            },
            async getstore_list(){
                try {
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    await  http.post('/wapi/Jur/getStore',data).then(res=>{
                        if (res.success === true){
                            this.store_list = res.data
                            console.log(res)
                        }
                    })
                }catch (e) {

                }
            },
            async getdistributor_list(){
                try {
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    await  http.post('/wapi/Jur/getDistributor',data).then(res=>{
                        if (res.success === true){
                            this.distributor_list = res.data
                            console.log(res)
                        }
                    })
                }catch (e) {

                }
            },
            querySearchAsync(queryString, cb){
                if (this.medicalName == true){
                    var sr = [];
                    if (queryString != undefined && queryString.length > 0){
                        let data = this.$store.getters.getDataInfo
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.queryString = queryString.trim()

                        http.post('/wapi/Jur/getInstitutions',data).then(res=>{
                            if (res.success === true){
                                // let data = res.data
                                // for (let i of data){
                                //     i.value = i.institution_name
                                // }
                                // cb(data)
                                cb(res.data)
                            }

                        })

                    }else{
                        cb(sr);
                    }
                } else if (this.retailName === true){
                    var sr = [];
                    if (queryString != undefined && queryString.length > 0){
                        let data={}
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.queryString = queryString.trim()
                        http.post('/wapi/Jur/getStore',data).then(res=>{
                            if (res.success === true){
                                //
                                // let data = res.data
                                // for (let i of data){
                                //     i.value = i.store_name
                                // }
                                // cb(data)
                                cb(res.data)
                            }

                        })

                    }else{
                        cb(sr);
                    }
                } else if (this.distributionName == true){
                    var sr = [];
                    if (queryString != undefined && queryString.length > 0){
                        let data={}
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.queryString = queryString.trim()
                        http.post('/wapi/Jur/getDistributor',data).then(res=>{
                            if (res.success === true){
                                //
                                // let data = res.data
                                // for (let i of data){
                                //     i.value = i.store_name
                                // }
                                // cb(data)
                                cb(res.data)
                            }

                        })

                    }else{
                        cb(sr);
                    }
                }

            },
            handleSelect(item){
                this.addFormInstiturions.institution_id = item
                // this.addFormInstiturions.institution_name = item.institution_name
            },
            handleSelectStore(item){
                this.addFormStore.store_id = item
                // this.addFormStore.store_name = item.store_name
            },
            handleSelectDistributorList(item){
                this.addFormDistributorList.distributor_id = item
                // this.addFormDistributorList.distributor_name = item.distributor_name
            },
            async getInstutionsList(){
                try {
                    this.loading = true
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id


                    await http.post('/wapi/Jur/getInstutionsList',data).then(res=>{


                        if (res.success){
                            // this.loading = false
                        }
                        // console.log(res.data,999)
                        this.tableInstutionsList = res.data.array
                        if (this.tableInstutionsList.length > 0){
                            this.tableInstutionsListLength=this.tableInstutionsList.length
                        }else {
                            this.tableInstutionsListLength=0
                        }

                        this.loading = false

                    })
                }catch (e) {
                    this.loading = false
                }
            },
            async getRetailstoreList(){

                try {
                    this.loading = true
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    //this.loading = false
                    await http.post('/wapi/Jur/getRetailstoreList',data).then(res=>{
                        if (res.success){
                            //this.loading = false
                        }
                        this.tableRetailstoreList = res.data.array
                        if (this.tableRetailstoreList.length > 0){
                            this.tableRetailstoreListLength=this.tableRetailstoreList.length
                        }else {
                            this.tableRetailstoreListLength=0
                        }
                        this.$nextTick(function () {
                            this.loading = false
                        })
                    })

                }catch (e) {
                    this.loading = false
                }

            },
            async getDistributorList(){

                try {
                    this.loading = true
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    //this.loading = false
                    await http.post('/wapi/Jur/getDistributorList',data).then(res=>{
                        console.log(res,222)
                        if (res.success){
                            //this.loading = false
                        }
                        this.tableDistributorList = res.data.array
                        if (this.tableDistributorList.length > 0){
                            this.tableDistributorListLength=this.tableDistributorList.length
                        }else {
                            this.tableDistributorListLength=0
                        }
                        this.$nextTick(function () {
                            this.loading = false
                        })
                    })

                }catch (e) {
                    this.loading = false
                }

            },
            async getProductList(){
                try {

                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    //this.loading = false
                    await http.post('/wapi/Jur/getProductList',data).then(res=>{
                        this.product_num = res.data.product_num
                    })

                }catch (e) {

                }
            },
            async addProductArray_fn(){
                try {

                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id

                    //this.loading = false
                    await http.post('/wapi/Jur/addProductArray1',data).then(res=>{
                        // console.log(res,5555)
                        this.addProductArray = res.data
                    })

                }catch (e) {

                }
            },
            async addTerritoryProductArray(reference_obj){
                try {

                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.reference_obj = reference_obj

                    //this.loading = false
                    await http.post('/wapi/Jur/getProductList_home',data).then(res=>{
                    // await http.post('/wapi/Jur/addTerritoryProductArray1',data).then(res=>{

                        this.addTerProductArray = res.data
                    })

                }catch (e) {

                }
            },
            info(a,b){

            },
            clickModelInstutionsList(index,row){
                this.modelInstitutions = true
                this.formInstiturions.territory_name = this.data.territory_name
                this.formInstiturions.territory_code = this.data.territory_code
                this.formInstiturions.territory_id = this.data.territory_id
                this.formInstiturions.institution_name = row.institution_name
                this.formInstiturions.institution_name = row.institution_name
                this.formInstiturions.institution_id = row.institution_id
                this.formInstiturions.productArray = []
                this.formInstiturions.productArraySelect = []
                for (let i =0;i<row.productArray.length;i++){
                    this.formInstiturions.productArray.push(row.productArray[i].product_id)
                    this.formInstiturions.productArraySelect.push(row.productArray[i].product_id)
                }
            },
            clickModelRetailstoreList(index,row){
                this.modelRetailstoreList = true
                this.formRetailstoreList.territory_name = this.data.territory_name
                this.formRetailstoreList.territory_code = this.data.territory_code
                this.formRetailstoreList.territory_id = this.data.territory_id
                this.formRetailstoreList.store_name = row.store_name
                this.formRetailstoreList.store_id = row.store_id
                this.formRetailstoreList.productArray = []
                this.formRetailstoreList.productArraySelect = []
                for (let i =0;i<row.productArray.length;i++){
                    this.formRetailstoreList.productArray.push(row.productArray[i].product_id)
                    this.formRetailstoreList.productArraySelect.push(row.productArray[i].product_id)
                }
            },
            clickModelDistributorList(index,row){
                console.log(row)
                this.modelDistributorList = true
                this.formDistributorList.territory_name = this.data.territory_name
                this.formDistributorList.territory_code = this.data.territory_code
                this.formDistributorList.territory_id = this.data.territory_id
                this.formDistributorList.distributor_name = row.distributor_name
                this.formDistributorList.distributor_id = row.distributor_id
                this.formDistributorList.productArray = []
                this.formDistributorList.productArraySelect = []
                for (let i =0;i<row.productArray.length;i++){
                    this.formDistributorList.productArray.push(row.productArray[i].product_id)
                    this.formDistributorList.productArraySelect.push(row.productArray[i].product_id)
                }
            },
            emoveTag(tag){
                //console.log(tag)
            },
            addInstitutions(){
                // console.log(this.addFormInstiturions)
                this.addModelInstitutions = true
                this.addFormInstiturions.territory_name = this.data.territory_name
                this.addFormInstiturions.territory_code = this.data.territory_code
                this.addFormInstiturions.territory_id = this.data.territory_id
            },
            addStore(){
                this.addModelStore = true
                this.addFormStore.territory_name = this.data.territory_name
                this.addFormStore.territory_code = this.data.territory_code
                this.addFormStore.territory_id = this.data.territory_id
            },
            addDistributor(){
                this.addModelDistributorList = true
                this.addFormDistributorList.territory_name = this.data.territory_name
                this.addFormDistributorList.territory_code = this.data.territory_code
                this.addFormDistributorList.territory_id = this.data.territory_id
            },
            inputSaveAddInstitutions() {
                this.$refs['addFormInstiturions'].validate((valid) => {
                    if (valid) {
                        this.saveAddInstitutions()
                    } else {
                        return false;
                    }
                });
            },
            closeAddModelInstitutions(){
                this.addModelInstitutions = false
                this.$refs['addFormInstiturions'].resetFields();
            },
            inputSaveAddStore() {
                this.$refs['addFormStore'].validate((valid) => {
                    if (valid) {
                        this.saveAddStore()
                    } else {
                        return false;
                    }
                });
            },
            closeAddModelStore(){
                this.addModelStore = false
                this.$refs['addFormStore'].resetFields();
            },
            inputSaveAddDistributorList() {
                this.$refs['addFormDistributorList'].validate((valid) => {
                    if (valid) {
                        this.saveAddDistributorList()
                    } else {
                        return false;
                    }
                });
            },
            closeAddModelDistributorList(){
                this.addModelDistributorList= false
                this.$refs['addFormDistributorList'].resetFields();
            },
            async saveAddInstitutions(){
                try {
                    let data = this.addFormInstiturions
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')
                    // if (!data.institution_id){
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择机构'
                    //     })
                    //     return false
                    // }
                    // if (data.productArray.length == 0){
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择推广产品'
                    //     })
                    // } else {
                    await http.post('/wapi/Jur/addInstitutions',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                            this.getInstutionsList()
                            this.getProductList()

                            let obj ={
                                productArray: [],
                                territory_name:'',
                                territory_code:'',
                                institution_name:'',
                                territory_id:'',
                                institution_id:''
                            }
                            this.sname=''
                            this.addFormInstiturions = obj
                            console.log(this.addFormInstiturions)
                        }
                    })
                    this.addModelInstitutions = false
                    // }

                }catch (e) {

                }
            },
            async saveAddStore(){
                try {
                    let data = this.addFormStore
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')
                    console.log(data)
                    // if (!data.store_id) {
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择门店'
                    //     })
                    //     return false
                    // }
                    // if (data.productArray.length == 0){
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择推广产品'
                    //     })
                    // } else {
                    await http.post('/wapi/Jur/addStore', data).then(res => {
                        if (res.success === true) {
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                            this.getRetailstoreList()
                            this.getProductList()

                            let obj = {
                                productArray: [],
                                territory_name: '',
                                territory_code: '',
                                store_name: '',
                                territory_id: '',
                                store_id: ''
                            }
                            this.snamestore = ''
                            this.addFormStore = obj
                        }
                    })
                    this.addModelStore = false
                    // }
                }catch (e) {

                }
            },
            async saveAddDistributorList(){
                try {
                    let data = this.addFormDistributorList
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')

                    // if (!data.distributor_id){
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择经销商'
                    //     })
                    //     return false
                    // }
                    // if (data.productArray.length == 0){
                    //     this.$message({
                    //         type: 'error',
                    //         message: '请选择推广产品'
                    //     })
                    // } else {
                    await http.post('/wapi/Jur/addDistributorList', data).then(res => {
                        if (res.success === true) {
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                            this.getDistributorList()
                            this.getProductList()

                            let obj = {
                                productArray: [],
                                territory_name: '',
                                territory_code: '',
                                distributor_name: '',
                                territory_id: '',
                                distributor_id: ''
                            }
                            this.addFormDistributorList = obj
                            this.snameDistributorList = ''
                        }
                    })

                    this.addModelDistributorList = false
                    // }
                }catch (e) {

                }
            },

            inputUpdateInstitutions() {
                this.$refs['formInstiturions'].validate((valid) => {
                    if (valid) {
                        this.updateInstitutions()
                    } else {
                        return false;
                    }
                });
            },
            closeModelInstitutions(){
                this.modelInstitutions = false
                this.$refs['formInstiturions'].resetFields();
            },
            inputUpdateRetailstoreList() {
                this.$refs['formRetailstoreList'].validate((valid) => {
                    if (valid) {
                        this.updateRetailstoreList()
                    } else {
                        return false;
                    }
                });
            },
            closeModelRetailstoreList(){
                this.modelRetailstoreList = false
                this.$refs['formRetailstoreList'].resetFields();
            },
            inputUpdateDistributorList() {
                this.$refs['formDistributorList'].validate((valid) => {
                    if (valid) {
                        this.updateDistributorList()
                    } else {
                        return false;
                    }
                });
            },
            closeModelDistributorList(){
                this.modelDistributorList = false
                this.$refs['formDistributorList'].resetFields();
            },

            async updateInstitutions(){

                try {
                    let data = this.formInstiturions
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')
                    // if (data.productArray.length > 0){
                    await http.post('/wapi/Jur/upDateInstitutions',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.getInstutionsList()
                            this.getProductList()
                        }
                    })
                    this.modelInstitutions = false
                    // } else {
                    //     this.$message({
                    //         type: 'error',
                    //         message: '产品不能为空'
                    //     })
                    // }

                }catch (e) {

                }
            },
            async updateRetailstoreList(){

                try {
                    let data = this.formRetailstoreList
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')
                    // if (data.productArray.length > 0){
                    await http.post('/wapi/Jur/upDateRetailstoreList',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.getRetailstoreList()

                        }
                    })
                    this.modelRetailstoreList = false
                    // } else {
                    //     this.$message({
                    //         type: 'error',
                    //         message: '产品不能为空'
                    //     })
                    // }

                }catch (e) {

                }
            },
            async updateDistributorList(){

                try {
                    let data = this.formDistributorList
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date().Format('yyyyMM')
                    // if (data.productArray.length > 0){
                    await http.post('/wapi/Jur/updateDistributorList',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.getDistributorList()

                        }
                    })
                    this.modelDistributorList = false
                    // } else {
                    //     this.$message({
                    //         type: 'error',
                    //         message: '产品不能为空'
                    //     })
                    // }

                }catch (e) {

                }
            },
            async clickRemove(index,row){
                try {
                    this.$confirm('此操作将移除机构, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let data = row
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.territory_id = this.data.territory_id
                        http.post('/wapi/Jur/clickRemove',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type: 'success',
                                    message: '移除成功'
                                })
                                this.getInstutionsList()
                                this.getProductList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }catch (e) {

                }
            },
            async clickRemoveRetailstoreList(index,row){
                try {
                    this.$confirm('此操作将移除门店, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let data = row
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.territory_id = this.data.territory_id
                        http.post('/wapi/Jur/clickRemoveRetailstoreList',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type: 'success',
                                    message: '移除成功'
                                })
                                this.getRetailstoreList()

                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }catch (e) {

                }
            },
            async clickRemoveDistributorList(index,row){
                try {
                    this.$confirm('此操作将移除经销商, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let data = row
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.territory_id = this.data.territory_id
                        http.post('/wapi/Jur/clickRemoveDistributorList',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type: 'success',
                                    message: '移除成功'
                                })
                                this.getDistributorList()

                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }catch (e) {

                }
            },
            tabHandleClick(item){
                if (item.label === '医疗机构') {
                    this.medicalName = true
                    this.retailName = false
                    this.distributionName = false
                    this.getInstutionsList()
                    this.addTerritoryProductArray('INSTITUTION')
                }else if (item.label === '零售终端') {
                    this.medicalName = false
                    this.distributionName = false
                    this.getRetailstoreList()
                    this.addTerritoryProductArray('RETAILSTORE')
                    this.retailName = true
                }else if (item.label === '分销客户') {
                    this.medicalName = false
                    this.retailName = false
                    this.distributionName = true
                    this.getDistributorList()
                    this.addTerritoryProductArray('DISTRIBUTOR')
                }
            },
            async getEndpointTerritoryInfo(){
                try{
                    let data = this.$store.getters.getDataInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    await http.post('/wapi/Jur/getEndpointTerritoryInfo',data).then(res=>{
                        if(res.success){
                            this.tableInstutionsListLength = res.data.institution_num
                            this.tableDistributorListLength = res.data.distributor_num
                            this.tableRetailstoreListLength = res.data.retailstore_num
                            this.cityList = res.data.cityArray
                            this.product_num = res.data.product_num
                        }else {
                            this.$message({
                                type: 'error',
                                message: '获取数据失败'
                            })
                        }
                    })
                }catch (e) {

                }
            },
        },
        mounted() {
            this.data = this.$store.getters.getDataInfo
            // console.log(this.data)
            this.getInstutionsList()
            this.getEndpointTerritoryInfo()

            // this.getProductList()
            this.addProductArray_fn()
            this.addTerritoryProductArray('INSTITUTION')
            // this.getCity()
            this.getinstitution_list()
            this.getstore_list()
            this.getdistributor_list()
        },
        updated() {
        },

    }
</script>

<style lang="scss" module>
    .container {
        .top {

        }
    }
</style>

<style scoped>
    .tableSpan{
        border-radius: 4px;
        font-size: 12px;
        display: inline-block;
        padding:1px 7px;
        background:#c680ff;
        color: white;
        margin-right: 4px;
        margin-top: 4px;
    }
    .tempCell{
        text-align: center;
    }
    .eltabs >>> .el-tabs__content{
        height: calc(100% - 50px);
        overflow-y: auto;
    }
    .eltabs >>> .el-tabs__header{
        margin: 0 0 15px!important;
    }

    #institutions >>> .el-dialog__header {
        padding: 10px 20px 10px;
    }
    #institutions >>> .el-dialog__body {
        padding: 10px 20px;
    }
    #institutions >>> .el-form-item__label {
        font-size: 16px;
        color: black;
    }
    #institutions >>> .el-form-item__error{
        left: 8.3%;
    }
    #institutions >>> .institutions_table_cell {
        color: #2b92fa !important;
    }
</style>
<style>
    #institutions .institutions_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/jurisdiction/institutionsTow.vue